import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  FloatInput,
} from "components/Input/Index.js";
import { site,meter } from "variables/patrimoine.js";
import {datedistributionData} from "variables/lists/meters";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import TextInput from "components/Input/TextInput";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330, 
    height: 400,
    marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "normal",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    marginRight: "0px",
    marginBottom: "0px",
    marginTop: "15px",
    fontFamily: '"Source Sans Pro",sans-serif',
    width: "96%",
    marginLeft: "2%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "normal",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    marginRight: "0px",
    marginBottom: "0px",
    marginTop: "15px",
    fontFamily: '"Source Sans Pro",sans-serif',
    width: "96%",
    marginLeft: "2%",
  },
}));

function EditMeterDialog(props) {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    energy,
    parameters,
    closeModal,
    refetch,
    idSelected,
    prevMetersList,
    meternumber,
    divisionunit,
    divisionvalue,
    datedistribution,
    functioncode,
    creditline,
    loaded,
    handleMeternumberChange,
    handleDivisionunitChange,
    handleDivisionvalueChange,
    handleDatedistributionChange,
    handleFunctioncodeChange,
    handleCreditlineChange,
    accountMeters,
    editedGroupId,
    editedMetersList,
  } = props;

  
  useEffect(() => {
    if (
      meternumber.length > 0 &&
      divisionunit.length > 0 &&
      divisionvalue.length > 0 &&
      datedistribution.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [meternumber, divisionunit, divisionvalue, datedistribution]);

  const handleSubmit = async (event) => {
    const indexToReplace = editedMetersList.findIndex(
      (x) => x.uuid === idSelected
    );

    const editedMeters = {
      meternumber,
      divisionunit,
      divisionvalue,
      datedistribution,
      functioncode,
      creditline,
      'uuid': idSelected,
    };

    const meterslist = editedMetersList;
    meterslist.splice(indexToReplace, 1, editedMeters);

    axios
      .put(
        getSite(editedGroupId, "energy." + energy + "." + parameters),
        meterslist,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
      })
      .catch(() => { });
  };

  const divisionUnitData = [
    { name: "%", id: "percent" },
    { name: "m²", id: "sqrmtr" },
    { name: "Autre", id: "other" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={site.energy[energy][parameters].meternumber}
                textInput={meternumber}
                disabled={true}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={site.energy[energy][parameters].divisionunit}
                selectValue={divisionunit}
                handleSelectValueChange={handleDivisionunitChange}
                data={divisionUnitData}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={site.energy[energy][parameters].divisionvalue}
                floatInput={divisionvalue}
                handleFloatInputChange={handleDivisionvalueChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={meter.datedistribution}
                selectValue={datedistribution}
                handleSelectValueChange={handleDatedistributionChange}
                data={datedistributionData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={meter.functioncode}
                textInput={functioncode}
                handleTextInputChange={handleFunctioncodeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={meter.creditline}
                textInput={creditline}
                handleTextInputChange={handleCreditlineChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              noWrap
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditMeterDialog;
